import React, { useState, useEffect, useRef } from 'react';
import './BackgroundMusic.css';

const BackgroundMusic: React.FC = () => {
  const [isMuted, setIsMuted] = useState(() => {
    // Load mute preference from localStorage
    const saved = localStorage.getItem('backgroundMusicMuted');
    return saved === 'true';
  });
  
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    // Create audio element
    const audio = new Audio('/assets/sounds/FEENJAM.mp3');
    audio.loop = true;
    audio.volume = 0.3;
    audio.muted = isMuted;
    audioRef.current = audio;

    // Try to play audio immediately
    const playAudio = () => {
      audio.play().catch(() => {
        // Autoplay prevented - silently handle
      });
    };

    // Attempt immediate playback
    playAudio();

    // Fallback: play on first user interaction (for autoplay restrictions)
    const handleFirstInteraction = () => {
      playAudio();
      document.removeEventListener('click', handleFirstInteraction);
      document.removeEventListener('keydown', handleFirstInteraction);
    };

    document.addEventListener('click', handleFirstInteraction);
    document.addEventListener('keydown', handleFirstInteraction);

    // Cleanup function
    return () => {
      audio.pause();
      document.removeEventListener('click', handleFirstInteraction);
      document.removeEventListener('keydown', handleFirstInteraction);
    };
  }, [isMuted]);

  const toggleMute = () => {
    const newMutedState = !isMuted;
    setIsMuted(newMutedState);
    
    // Save preference to localStorage
    localStorage.setItem('backgroundMusicMuted', newMutedState.toString());
    
    // Update audio element if it exists
    if (audioRef.current) {
      audioRef.current.muted = newMutedState;
    }
  };

  return (
    <button 
      className="header-action-button"
      onClick={toggleMute}
      title={isMuted ? "Unmute music" : "Mute music"}
      aria-label={isMuted ? "Unmute background music" : "Mute background music"}
    >
      {isMuted ? "🔇" : "🎵"}
    </button>
  );
};

export default BackgroundMusic;
